// Function to calculate term frequency (TF)
function calculateTF(text) {
  const words = text.toLowerCase().match(/\b\w+\b/g) || [];
  const tf = {};
  words.forEach((word) => {
    tf[word] = (tf[word] || 0) + 1;
  });
  // Normalize by document length
  Object.keys(tf).forEach((word) => {
    tf[word] = tf[word] / words.length;
  });
  return tf;
}

// Function to calculate inverse document frequency (IDF)
function calculateIDF(documents) {
  const idf = {};
  const totalDocs = documents.length;

  // Collect all unique words
  const uniqueWords = new Set(
    documents.flatMap((doc) => doc.toLowerCase().match(/\b\w+\b/g) || [])
  );

  // Calculate IDF for each word
  uniqueWords.forEach((word) => {
    const docsWithWord = documents.filter((doc) =>
      (doc.toLowerCase().match(/\b\w+\b/g) || []).includes(word)
    ).length;
    idf[word] = Math.log(totalDocs / (1 + docsWithWord)) + 1;
  });

  return idf;
}

// Function to calculate TF-IDF vector
function calculateTFIDF(tf, idf) {
  const tfidf = {};
  Object.keys(tf).forEach((word) => {
    tfidf[word] = tf[word] * (idf[word] || 0);
  });
  return tfidf;
}

// Function to calculate cosine similarity between two vectors
function cosineSimilarity(vec1, vec2) {
  const intersection = Object.keys(vec1).filter(
    (word) => vec2[word] !== undefined
  );

  // If no common words, return 0
  if (intersection.length === 0) return 0;

  // Calculate dot product
  const dotProduct = intersection.reduce(
    (sum, word) => sum + vec1[word] * vec2[word],
    0
  );

  // Calculate magnitudes
  const mag1 = Math.sqrt(
    Object.values(vec1).reduce((sum, val) => sum + val * val, 0)
  );
  const mag2 = Math.sqrt(
    Object.values(vec2).reduce((sum, val) => sum + val * val, 0)
  );

  return dotProduct / (mag1 * mag2);
}

// Main function to calculate similarity scores
function calculateSimilarityScores(query, documents) {
  // Add query to documents for IDF calculation
  const allDocs = [query, ...documents];

  // Calculate IDF using all documents including query
  const idf = calculateIDF(allDocs);

  // Calculate TF-IDF for query
  const queryTF = calculateTF(query);
  const queryTFIDF = calculateTFIDF(queryTF, idf);

  // Calculate similarity scores
  const scores = documents.map((doc) => {
    const docTF = calculateTF(doc);
    const docTFIDF = calculateTFIDF(docTF, idf);
    return cosineSimilarity(queryTFIDF, docTFIDF);
  });

  return scores;
}

export { calculateSimilarityScores };
